/** Read-only lookups backing the notification-block editor's type-aware inputs:
 *  rulesets (ruleset type) and the registered predefined function names
 *  (function type). Hand-authored wrapper. */
import { apiGet } from './client';
import type { TenantRef } from './tours';
import type { PaginatedResponse } from './users';

export interface RulesetRef {
  id: number;
  codename: string | null;
  name: string;
  tenant: TenantRef | null;
}

export interface LookupParams {
  search?: string;
  pageSize?: number;
  /** int, or 'system' / 'null'. */
  tour_operator_id?: number | 'system' | 'null';
}

function toQuery(params: LookupParams): string {
  const usp = new URLSearchParams();
  if (params.search) usp.set('search', params.search);
  if (params.pageSize) usp.set('page_size', String(params.pageSize));
  if (params.tour_operator_id !== undefined) {
    usp.set('tour_operator_id', String(params.tour_operator_id));
  }
  const qs = usp.toString();
  return qs ? `?${qs}` : '';
}

export function listRulesets(params: LookupParams = {}): Promise<PaginatedResponse<RulesetRef>> {
  return apiGet<PaginatedResponse<RulesetRef>>(`/notification_rulesets/${toQuery(params)}`);
}

/** The registered predefined block-function names (empty → none available). */
export function listBlockFunctions(): Promise<string[]> {
  return apiGet<{ functions: string[] }>('/notification_block_functions/').then(
    (r) => r.functions,
  );
}
